import { supportAPI } from '@/lib/api';
import usePolledCount from '@/hooks/usePolledCount';

export const SUPPORT_READ_EVENT = 'farm-africa:support-read';

const EVENTS = [SUPPORT_READ_EVENT];
const fetchUnread = async () => (await supportAPI.unread())?.data?.unread;

/** Support replies the user hasn't read, for the header badge. */
export default function useSupportUnread() {
  return usePolledCount(fetchUnread, EVENTS);
}
